<!-- #45: a release happened while this tab was open. The existing warning-alert look; it never reloads by itself. -->
<div class="alert alert-warning d-flex align-items-center mb-0 rounded-0 position-sticky top-0" style="z-index: 1100"
  *ngIf="appVersion.updateAvailable$ | async">
  <span>A new version of MDP TOS has been released. Reload to keep working — anything typed on this screen will need re-entering.</span>
  <button type="button" class="btn btn-sm btn-warning ms-auto" (click)="appVersion.reload()">Reload</button>
</div>
<app-toast aria-live="polite" aria-atomic="true"></app-toast>
<router-outlet></router-outlet>
